// extracted by mini-css-extract-plugin
export default {"wrapper":"Terms_wrapper__hjHpM","logo":"Terms_logo__fWbhn","alphabetList":"Terms_alphabetList__AtfuW"};